export const getPredictedDate = (operationalFrom, averageUsageDays) => {
  if (!operationalFrom || !averageUsageDays) return null;

  const startDate = new Date(operationalFrom);
  const predicted = new Date(startDate);
  predicted.setDate(predicted.getDate() + averageUsageDays);

  return predicted;
};

export const getRemainingDays = (predictedDate) => {
  if (!predictedDate) return null;

  const today = new Date();
  const prediction = new Date(predictedDate);

  // Compare only dates, not time
  today.setHours(0, 0, 0, 0);
  prediction.setHours(0, 0, 0, 0);

  const differenceInDays = Math.round(
    (prediction - today) / (1000 * 60 * 60 * 24)
  );

  // Today
  if (differenceInDays === 0) {
    return 0;
  }

  // Future date: inclusive count
  if (differenceInDays > 0) {
    return differenceInDays + 1;
  }

  // Past date
  return differenceInDays;
};